import script from "./article-operation.vue?vue&type=script&setup=true&lang=js"
export * from "./article-operation.vue?vue&type=script&setup=true&lang=js"

import "./article-operation.vue?vue&type=style&index=0&id=2e962449&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e962449"]])

export default __exports__